export default __webpack_public_path__ + "static/media/background.84f51744.jpg";